// extracted by mini-css-extract-plugin
module.exports = {"ThemeSwitcher":"ThemeSwitcher_ThemeSwitcher__1OL02","ThemeSwitcher_light":"ThemeSwitcher_ThemeSwitcher_light__3eltS","ThemeSwitcher_dark":"ThemeSwitcher_ThemeSwitcher_dark__1n54z"};